import { GET } from './ApiService'

const urlFactory = {
    getEnvelops: () => `/api/seb-recipient-dashboard/envelope`,
}

const DashboardService = {
    getEnvelops: async () => {
        const params = {
            timestamp: Date.now(),
        }
        return GET(urlFactory.getEnvelops(), params)
    },
}

export default DashboardService
